import { z } from 'zod';

export const SlaFailureReasons = {
  TRANSCRIPTION_FAILURE: 'Transcription failure',
  AUDIO_QUALITY_ISSUES: 'Audio quality issues',
  SYSTEM_OUTAGE: 'System outage or downtime',
  PROCESSING_BACKLOG: 'Processing backlog',
  NETWORK_CONNECTIVITY: 'Network connectivity issues (client-side)',
  FILE_UPLOAD_FAILURE: 'File upload failure',
  LLM_TIMEOUT: 'LLM processing timeout',
  CUSTOMER_DEVICE_ISSUE: 'Customer device issue',
  SHORT_OR_EMPTY_AUDIO: 'Short or empty audio recording',
  LLM_SCHEMA_VALIDATION: 'LLM schema validation failure',
  LOST_AUDIO: 'Lost audio',
  UNKNOWN: 'Unknown/Under investigation',
  OTHER: 'Other (custom reason)',
} as const;

export type SlaFailureReasonKey = keyof typeof SlaFailureReasons;

export const slaFailureReasonMetadataSchema = z.object({
  reason: z.string(),
  customReason: z.string().optional(),
});

export type SlaFailureReasonMetadata = z.infer<
  typeof slaFailureReasonMetadataSchema
>;
